/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react-hooks/exhaustive-deps */
import React, { JSX, useEffect, useState } from 'react';

import { BaseTable, Button } from '@sede-enterprise/shell-ds-react-framework';

import dayjs from 'dayjs';

import Loader from '../../../../UI/Loader';
import { Modal } from '../../../../UI/Modal';
import { sendNotification } from '../../../../UI/Notification';
import {
  GET_ZKEY_MAPPING_AUDIT_LOGS,
  MESSAGES,
} from '../../../../constants/BeachSwaps';
import { get } from '../../../../services/GenesisApi';
import {
  IMappingAuditLogs,
  IZKeyAuditLogsContainer,
} from '../../../../types/BeachSwaps.type';
import { UK_TIME_ZONE } from '../../../../constants/Common';
import { AuditDetailWrapper, ModalFooter } from '../style';

const TWO = 2;
const ONE_SIX = 16;

const AuditLogs: React.FC<IZKeyAuditLogsContainer> = ({
  open = false,
  onClose = () => {},
  selectedItem,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [auditLogs, setAuditLogs] = useState<IMappingAuditLogs[]>([]);

  useEffect(() => {
    if (selectedItem && open) {
      setLoading(true);
      get(`${GET_ZKEY_MAPPING_AUDIT_LOGS}?mappingId=${selectedItem.id}`)
        .then((response) => {
          const secureId = crypto
            .getRandomValues(new Uint8Array(ONE_SIX))
            .reduce(
              (acc, byte) => acc + byte.toString(ONE_SIX).padStart(TWO, '0'),
              ''
            );

          const data = response.data ?? [];
          const dataWithUniqueID = data.map((item: IMappingAuditLogs) => ({
            ...item,
            id: Date.now().toString() + secureId,
          }));
          setAuditLogs(
            dataWithUniqueID.sort((itemOne, ItemTwo) => ItemTwo.id - itemOne.id)
          );
        })
        .catch(() => {
          sendNotification({
            type: 'error',
            message: MESSAGES.SERVER_ERROR,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [selectedItem, open]);

  const handleOnClose = () => {
    setAuditLogs([]);
    onClose();
  };

  const renderFooter = () => (
    <ModalFooter>
      <Button variant='outlined' onClick={handleOnClose} data-testid='Close'>
        Close
      </Button>
    </ModalFooter>
  );

  const renderMessage = (item: IMappingAuditLogs) => {
    return <span>{item.note}</span>;
  };

  const renderTime = (value: string): JSX.Element => (
    <div>{`${dayjs(value).format('ddd DD-MMM-YY HH:mm:ss A')}`}</div>
  );

  const columns = [
    {
      accessorKey: 'note',
      header: 'Message',
      cell: ({ row }) => renderMessage(row?.original),
    },
    {
      accessorKey: 'modifiedDate',
      header: 'Timestamp',
      width: 220,
      cell: ({ getValue }): JSX.Element => renderTime(getValue() as string),
    },
  ];

  return (
    <Modal
      open={open}
      onClose={handleOnClose}
      title='zKey Info and Audit Logs'
      isDraggable
      maskClosable={false}
      footer={renderFooter()}
      width={700}
    >
      {selectedItem && (
        <AuditDetailWrapper>
          <div>
            <span className='title'>Counterparty :</span>{' '}
            {selectedItem?.counterPartyName}
          </div>
          <div>
            <span className='title'>Terminal :</span>{' '}
            {selectedItem?.terminalName}
          </div>
          <div>
            <span className='title'>Sub Terminal :</span>{' '}
            {selectedItem?.subTerminalName}
          </div>
          <div>
            <span className='title'>Audit Logs:</span>
          </div>
          <div>
            {loading ? (
              <Loader />
            ) : (
              <BaseTable columns={columns} data={auditLogs} size='small' />
            )}
          </div>
        </AuditDetailWrapper>
      )}
    </Modal>
  );
};

export default AuditLogs;
